import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ProductCondition } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

type ProductConditionsState = ProductState['productConditions'];

export const getProductConditionsState: MemoizedSelector<StateWithProduct, ProductConditionsState> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.productConditions,
);

export const getProductConditions = (
  productCode: string,
): MemoizedSelector<StateWithProduct, StateUtils.LoaderState<ProductCondition[]>> =>
  createSelector(getProductConditionsState, (state: ProductConditionsState) =>
    StateUtils.entityLoaderStateSelector<ProductCondition[]>(state, productCode),
  );

export const getProductConditionsValue = (code: string): MemoizedSelector<StateWithProduct, ProductCondition[]> =>
  createSelector(getProductConditionsState, (state) => StateUtils.entityValueSelector(state, code));

export const getProductConditionsLoading = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getProductConditionsState, (state) => StateUtils.entityLoadingSelector(state, code));

export const getProductConditionsSuccess = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getProductConditionsState, (state) => StateUtils.entitySuccessSelector(state, code));

export const getProductConditionsError = (code: string): MemoizedSelector<StateWithProduct, boolean> =>
  createSelector(getProductConditionsState, (state) => StateUtils.entityErrorSelector(state, code));
